import {
  addressSchema,
  addressUI,
  phoneUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import content from '../../../../locales/en/content.json';
import { FULL_SCHEMA } from '../../../../utils/imports';

const TITLE_TEXT = content['household-info--spouse-contact-info-title'];
const INPUT_LABELS = {
  checkbox: content['form-label--military-address'],
  phone: content['contact-info--phone-label'],
};

const ADDRESS_PROPS = FULL_SCHEMA.properties.spouseAddress.properties;
const { spousePhone } = FULL_SCHEMA.properties;

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT),
    spouseAddress: addressUI({
      labels: { militaryCheckbox: INPUT_LABELS.checkbox },
    }),
    spousePhone: phoneUI(INPUT_LABELS.phone),
  },
  schema: {
    type: 'object',
    required: ['spouseAddress'],
    properties: {
      spouseAddress: addressSchema({ extend: ADDRESS_PROPS }),
      spousePhone,
    },
  },
};
